import http from "../../http-common";

export default class ImpexiumSubscriptionsUpdate {
  postPreferenceSubscriptions(userId: string, subscriptionField: {name: string, value: string}[]) {
    let url = `/impexium/subscriptions/${userId}`;

    return http.post(url, subscriptionField);
  }
}